import useContext from '../../hooks/useContext';
import { PostalContext } from '../../providers/postal';
import { StoreContext } from '../../providers/store';

export default () => {
  const { loading: fetchingData, postal } = useContext(PostalContext);
  const {
    adjacentUserStores: adjacentUserStores,
    userStore,
    updateUserStore,
  } = useContext(StoreContext);

  let store: ILimitedStore | undefined = undefined;

  if (!fetchingData && userStore) {
    store = userStore as ILimitedStore;
  } else if (!fetchingData && adjacentUserStores) {
    store = adjacentUserStores?.[0] as ILimitedStore;
  }

  return {
    loading: fetchingData,
    postal,
    updateUserStore,
    userStore: store,
  };
};
